import { render } from "./WardsAdd.vue?vue&type=template&id=7e2a848a&scoped=true"
import script from "./WardsAdd.vue?vue&type=script&lang=js"
export * from "./WardsAdd.vue?vue&type=script&lang=js"

import "./WardsAdd.vue?vue&type=style&index=0&id=7e2a848a&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e2a848a"]])

export default __exports__